module.exports = __webpack_public_path__ + "img/sync-alt.cc21bb0a.svg";